import { useLocation } from "react-router-dom";
import ItensMenu from "../menu/ItensMenu";
import "../menu/Sidebar.css";
import "./RealgemsSidebar.css";

const RealgemsSidebar = ({ close }) => {
  const location = useLocation();
  const dashboardActive = location.pathname.startsWith("/realgems/dashboard")
    ? "active"
    : "";
  const clientsActive = location.pathname.startsWith("/realgems/clientes") ? "active" : "";
  const ordersActive = location.pathname.startsWith("/realgems/pedidos") ? "active" : "";
  const presentationsActive = location.pathname.startsWith("/realgems/apresentacoes")
    ? "active"
    : "";
  const machinesSupportActive =
    location.pathname.startsWith("/realgems/maquinas") ||
    location.pathname.startsWith("/realgems/videos")
      ? "active"
      : "";

  return (
    <aside className={`sidebar partner-sidebar ${close ? "collapsed" : ""}`} id="sidebar">
      <div className="sidebar-header partner-sidebar-header">
        <div className="partner-logos-stack">
          <div className="partner-logo-card smart">
            <img src="/logo-horizontal.png" alt="Smart Olfativos" />
          </div>
          <div className="partner-logo-card realgems">
            <img src="/logo-realgems.svg" alt="Realgems" />
          </div>
        </div>

        <div className="partner-sidebar-copy">
          <div className="sidebar-title-1">Portal Parceiro</div>
          <div className="sidebar-title-2">Smart Olfativos + Realgems</div>
        </div>
      </div>

      <nav className="sidebar-menu">
        <ItensMenu
          active={dashboardActive}
          icone={"#"}
          nome="Dashboard Realgems"
          link="/realgems/dashboard"
        />
        <ItensMenu active={clientsActive} icone={"@"} nome="Clientes" link="/realgems/clientes" />
        <ItensMenu
          active={ordersActive}
          icone={"\uD83D\uDCDD"}
          nome="Pedidos"
          link="/realgems/pedidos"
        />
        <ItensMenu
          active={presentationsActive}
          icone={"\uD83D\uDCFD\uFE0F"}
          nome="Apresentações"
          link="/realgems/apresentacoes"
        />
        <ItensMenu
          active={machinesSupportActive}
          icone={">"}
          nome="Máquinas"
          link="/realgems/maquinas"
        />
      </nav>

      <div className="sidebar-footer partner-sidebar-footer">
        <div>Portal em implantação</div>
        <div>Smart Olfativos x Realgems</div>
      </div>
    </aside>
  );
};

export default RealgemsSidebar;
